import {API} from "@/Composables/api";

const getGroupMembers = async (group: string, params = {}) => {
    return API.get(route("groups.members.index", {group}), params);
};

const getGroupMember = async (group, user, params = {}) => {
    return API.get(route("groups.members.show", {group, user}), params);
};

const getGroupInvitation = async (group: string, member: string, params = {}) => {
    return API.get(route("groups.invitations.show", {group}), params);
};

const acceptInvite = async (group: string, invitation: string, params = {}) => {
    return API.put(route("groups.members.invitations.accept", {group, invitation}), params);
};

const declineInvite = async (group: string, invitation: string, params = {}) => {
    return API.put(route("groups.members.invitations.decline", {group, invitation}), params);
};

const getGroupMemberStats = async (group: string, member: string, params = {}) => {
    return API.get(route("groups.members.stats.show", {group, member}), params);
};

const storeGroupMembers = async (group: string, formData, params = {}) => {
    return API.post(route("groups.members.add", {group}), params, formData);
};

const changeGroupMemberRole = async (group: string, user: string, formData, params = {}) => {
    return API.put(route("groups.members.change-role", {group, user}), params, formData);
};

const massChangeGroupMemberRole = async (group: string, formData, params = {}) => {
    return API.put(route("groups.members.mass-change-role", {group}), params, formData);
};

const removeGroupMember = async (group: string, user: string, params = {}) => {
    return API.delete(route("groups.members.destroy", {group, user}), params);
};

const syncGroupMembers = async (group: string, members, params = {}) => {
    return API.post(route("groups.members.sync", {group}), params, {members});
};

export {
    getGroupMembers,
    getGroupMember,
    storeGroupMembers,
    changeGroupMemberRole,
    massChangeGroupMemberRole,
    removeGroupMember,
    syncGroupMembers,
    getGroupMemberStats,
    acceptInvite,
    declineInvite,
};
